import { render } from "./CMS.vue?vue&type=template&id=5ad1f2ff&ts=true"
import script from "./CMS.vue?vue&type=script&lang=ts"
export * from "./CMS.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__